import React from "react";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputMask from "react-input-mask";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getData } from "../../../services/library";
import ErrorDialog from "../../Dialogs/ErrorDialog";
import { verificarCuit, verificarDni } from "../../referencias-tablas/clientes/validaciones";

function FormCliente(props) {
  const [localidades, setLocalidades] = useState(null);
  const [segmentos, setSegmentos] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [sitIva, setSitIva] = useState(null);
  const [empresas, setEmpresas] = useState();
  const [condicionesPago, setCondicionesPago] = useState(null);
  const [unidadesFact, setUnidadesFact] = useState(null);
  const [sucursales, setSucursales] = useState();
  const [errorDialog, setErrorDialog] = useState(false);
  const [convenios, setConvenios] = useState();

  const almacenar = (e) => {
    props.setDataCliente({
      ...props.dataCliente,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  //Fetchs para traer datos de la api a los desplegables
  useEffect(() => {
    getData("/condicion_pago", setCondicionesPago);
    getData("/desplegables/unidadFact", setUnidadesFact);
    getData("/condiciones_iva/activos", setSitIva);
    getData("/provincias", setProvincias);
    getData("/empresas/granel", setEmpresas);
    getData("/convenios", setConvenios);
    props.dataCliente.id_empresa && getData("/sucursales/empresayotra/" + props.dataCliente.id_empresa, setSucursales);
    props.dataCliente.id_provincia && getData(`/localidades/prov/${props.dataCliente.id_provincia}`, setLocalidades)
    props.dataCliente.id_sucursal && props.dataCliente.id_empresa && getData(`/segmentos/con_precio_asignado/${props.dataCliente.id_sucursal}/${props.dataCliente.id_empresa}`, setSegmentos)
  }, []);

  useEffect(() => {
    props.dataCliente.id_empresa && props.dataCliente.id_sucursal && getData(`/segmentos/con_precio_asignado/${props.dataCliente.id_sucursal}/${props.dataCliente.id_empresa}`, setSegmentos);
  }, [props.dataCliente.id_empresa, props.dataCliente.id_sucursal]);


  const style = {
    backgroundColor: "#fff",
    width: "100%",
  };

  const variant = "standard";
  const readOnly = props.readOnly;
  const txtProps = {};

  useEffect(() => {
    if (!props.edicion) {
      if (props.esDomEntrega === true) {
        props.setDataDir((prevDataDir) => ({
          ...prevDataDir,
          id_provincia: props.dataCliente.id_provincia,
          id_localidad: props.dataCliente.id_localidad,
          telefono1: props.dataCliente.telefono1,
          telefono2: props.dataCliente.telefono2,
          telefono3: props.dataCliente.telefono3,
          mails: props.dataCliente.mails,
          id_sucursal: props.dataCliente.id_sucursal,
          direccion_entrega: props.dataCliente.direccion_fiscal
        }));
      }
    }
  }, [
    props.esDomEntrega,
    props.dataCliente.id_provincia,
    props.dataCliente.id_localidad,
    props.dataCliente.telefono1,
    props.dataCliente.telefono2,
    props.dataCliente.telefono3,
    props.dataCliente.mails,
    props.dataCliente.id_sucursal,
    props.dataCliente.direccion_fiscal
  ]);

  const edicion = props.edicion || false;

  return (
    <div>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        alignContent="stretch"
        wrap="wrap"
        p={1}
        maxWidth="xl"
      >
        <Grid item xs={edicion ? 12 : 6}>
          <TextField
            autoFocus
            focused={txtProps.focused}
            disabled={props.dataCliente.apellido || props.dataCliente.apellido}
            required={!props.dataCliente.apellido && !props.dataCliente.nombre}
            autoComplete="off"
            color="primary"
            variant={variant}
            style={style}
            type="text"
            name="razon_social"
            label="Razon Social"
            size="small"
            onChange={almacenar}
            value={
              props.dataCliente.razon_social &&
              props.dataCliente.razon_social.toUpperCase()
            }
            inputProps={{ maxLength: 200, readOnly: readOnly }}
          />
        </Grid>
        {!edicion && (
          <>
            <Grid item xs={3}>
              <TextField
                focused={txtProps.focused}
                disabled={!!props.dataCliente.razon_social}
                required={!props.dataCliente.razon_social}
                autoComplete="off"
                color="primary"
                variant={variant}
                style={style}
                type="text"
                name="apellido"
                label="Apellido"
                size="small"
                onChange={almacenar}
                value={
                  props.dataCliente.apellido &&
                  props.dataCliente.apellido.toUpperCase()
                }
                inputProps={{ maxLength: 200, readOnly: readOnly }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                focused={txtProps.focused}
                disabled={!!props.dataCliente.razon_social}
                required={!props.dataCliente.razon_social}
                autoComplete="off"
                color="primary"
                variant={variant}
                style={style}
                type="text"
                name="nombre"
                label="Nombre"
                size="small"
                onChange={almacenar}
                inputProps={{ maxLength: 200, readOnly: readOnly }}
                value={
                  props.dataCliente.nombre &&
                  props.dataCliente.nombre.toUpperCase()
                }
              />
            </Grid>
          </>
        )}
        <Grid
          item
          xs={3}
        >
          <FormControl
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
            focused={txtProps.focused}
          >
            <InputLabel>Cuit/Dni</InputLabel>
            <Select
              name="tipo_doc_afip"
              value={props.dataCliente.tipo_doc_afip}
              label="Cuit/Dni"
              onChange={almacenar}
            >
              <MenuItem key={1} value={80}>
                Cuit
              </MenuItem>
              <MenuItem key={2} value={96}>
                Dni
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {props.dataCliente.tipo_doc_afip === 80 ? (
          <Grid
            item
            xs={3}
          >
            <InputMask
              mask="99-99999999-9"
              value={props.dataCliente.cuit}
              maskChar=" "
              onChange={(e) =>
                props.setDataCliente({
                  ...props.dataCliente,
                  cuit: e.target.value,
                })
              }
              onBlur={(e) =>
                verificarCuit(
                  props.dataCliente,
                  props.setDataCliente,
                  setErrorDialog
                )
              }
              disabled={readOnly}
            >
              {() => (
                <TextField
                  required
                  variant={variant}
                  size="small"
                  style={style}
                  type="text"
                  name="cuit"
                  label="Numero Cuit"
                  focused={txtProps.focused}
                />
              )}
            </InputMask>
          </Grid>
        ) : (
          <Grid
            item
            xs={3}
          >
            <InputMask
              mask="99.999.999"
              value={props.dataCliente.cuit}
              disabled={readOnly}
              maskChar=" "
              onChange={almacenar}
              onBlur={(e) =>
                verificarDni(
                  props.dataCliente,
                  props.setDataCliente,
                  setErrorDialog
                )
              }
            >
              {() => (
                <TextField
                  required
                  variant={variant}
                  size="small"
                  style={style}
                  type="text"
                  name="cuit"
                  label="Numero Dni"
                  focused={txtProps.focused}
                  disabled={readOnly}
                />
              )}
            </InputMask>
          </Grid>
        )}
        <Grid item xs={3}>
          <FormControl required style={style} size="small">
            <InputLabel>Condición de pago</InputLabel>
            <Select
              name="id_condicionpago"
              value={props.dataCliente.id_condicionpago}
              label="Condición de pago"
              onChange={almacenar}
              variant="standard"
              disabled={readOnly}
            >
              {condicionesPago
                ? condicionesPago.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.condicion}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            style={style}
            size="small"
            variant={variant}
            disabled={readOnly}
            focused={txtProps.focused}
            required
          >
            <InputLabel> Situacion Iva</InputLabel>
            <Select
              required
              label="Situacion Iva"
              name="situacion_iva"
              value={props.dataCliente.situacion_iva}
              onChange={(e) => {
                props.setDataCliente({
                  ...props.dataCliente,
                  situacion_iva: e.target.value || null,
                  id_convenio: null
                });
                props.setShowDropdownConvenios(Boolean(sitIva?.find((sit => sit.id === e.target.value)).inscripcion_iibb))
              }}
            >
              {sitIva
                ? sitIva.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.descripcion}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>

        {/* si es responsable inscripto tengo que agregar el convenio que tiene:  */}
        {props.showDropdownConvenios && (
          <Grid item xs={9}>
            <FormControl
              style={style}
              size="small"
              variant={variant}
              disabled={readOnly}
              focused={txtProps.focused}
              required
            >
              <InputLabel>Sit. Frente a IIBB</InputLabel>
              <Select
                required
                label="Sit. Frente a IIBB"
                name="id_convenio"
                value={props?.dataCliente?.id_convenio}
                onChange={almacenar}
              >
                {convenios && convenios.length > 0 && props.dataCliente.situacion_iva &&
                  convenios
                    .filter((convenio) => {
                      try {
                        const config = JSON.parse(convenio.config);
                        if (!config.cond_iva_permitida) return false;
                        const ivasPermitidos = config.cond_iva_permitida.split(',').map(item => item.trim());
                        return ivasPermitidos.includes(String(props.dataCliente.situacion_iva));
                      } catch (e) {
                        return false;
                      }
                    })
                    .map((conv) => (
                      <MenuItem key={conv.id_convenio} value={conv.id_convenio}>
                        {conv.convenio}
                      </MenuItem>
                    ))
                }
                {/* {convenios && convenios?.length > 0
                ? convenios?.map((conv) => (
                    <MenuItem key={conv?.id} value={conv?.id_convenio}>
                      {conv?.convenio}
                    </MenuItem>
                ))
                :
                <MenuItem> No hay convenios registrados </MenuItem>} */}
              </Select>
            </FormControl>
          </Grid>
        )}
        {/* {parseInt(props.dataCliente.situacion_iva) === 1 && ( */}
        {props.dataCliente.situacion_iva == 1 && (
          <Grid item xs={3}>
            <FormControlLabel
              sx={{ "& .MuiFormControlLabel-label": { fontSize: 13 } }}
              style={{ fontSize: 10 }}
              labelPlacement="center"
              control={
                <Checkbox
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                  disabled={readOnly}
                  checked={props.dataCliente.facturacion_especial === 1}
                  onChange={(e) =>
                    props.setDataCliente({
                      ...props.dataCliente,
                      facturacion_especial: e.target.checked ? 1 : 0,
                    })
                  }
                />
              }
              label="Facturación ESPECIAL"
            />
          </Grid>
        )}
        <Grid item xs={props.edicion ? 6 : 4}>
          <TextField
            focused={txtProps.focused}
            autoComplete="off"
            variant={variant}
            size="small"
            required
            style={style}
            placeholder="Direccion Fiscal"
            id="direccion_fiscal"
            name="direccion_fiscal"
            label="Direccion Fiscal"
            color="primary"
            value={
              props.dataCliente.direccion_fiscal &&
              props.dataCliente.direccion_fiscal.toUpperCase()
            }
            onChange={almacenar}
            inputProps={{ maxLength: 120, readOnly: readOnly }}
          />
        </Grid>
        {/* <Grid item xs={props.edicion ?  3: 3}> */}
        <Grid item xs={3}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel> Provincia </InputLabel>
            <Select
              label="Provincia"
              color="primary"
              name="id_provincia"
              value={props.dataCliente.id_provincia}
              onChange={(e) => {
                props.setDataCliente({
                  ...props.dataCliente,
                  id_provincia: e.target.value,
                  id_localidad: "",
                });
                getData(`/localidades/prov/${e.target.value}`, setLocalidades)
              }}
            >
              {provincias
                ? provincias.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.provincia}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel>Localidad</InputLabel>
            <Select
              label="Localidad"
              name="id_localidad"
              value={props.dataCliente.id_localidad}
              onChange={almacenar}
            >
              {localidades
                ? localidades.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.localidad}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        {!props.edicion && (
          <Grid item xs={2}>
            <FormControlLabel
              sx={{ "& .MuiFormControlLabel-label": { fontSize: 13 } }}
              labelPlacement="right"
              control={
                <Checkbox
                  checked={props.esDomEntrega}
                  onChange={(e) => props.setEsDomEntrega(e.target.checked)}
                />
              }
              label="DOMICILIO ENTREGA"
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel> Empresa </InputLabel>
            <Select
              label="Empresa"
              color="primary"
              name="id_empresa"
              value={props.dataCliente.id_empresa}
              onChange={(e) => {
                props.setDataCliente({
                  ...props.dataCliente,
                  id_empresa: e.target.value,
                  id_sucursal: ""
                });
                getData("/sucursales/empresayotra/" + e.target.value, setSucursales);
              }}
            >
              {empresas
                ? empresas.map((elemento) => (
                  <MenuItem
                    key={elemento.idempresa}
                    value={elemento.idempresa}
                  >
                    {elemento.empresa}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel> Sucursal </InputLabel>
            <Select
              label="Sucursal"
              color="primary"
              name="id_sucursal"
              value={props.dataCliente.id_sucursal}
              onChange={(e) => {
                almacenar(e);
              }}
            >
              {sucursales
                ? sucursales.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.nombre}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel
              disabled={readOnly || !props.dataCliente.id_empresa || !props.dataCliente.id_sucursal}
            >Segmento</InputLabel>
            <Select
              disabled={readOnly || !props.dataCliente.id_empresa || !props.dataCliente.id_sucursal}
              label="Segmento"
              name="id_segmento"
              value={props.dataCliente.id_segmento}
              onChange={(e) => {
                props.setDataCliente({
                  ...props.dataCliente,
                  id_segmento: e.target.value,
                  id_subsegmento: "",
                });
                // getData(`/subsegmentos/seg/${e.target.value}`, setSubsegmentos);
              }}

            >
              {segmentos
                ? segmentos.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.segmento}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            style={style}
            size="small"
            disabled={readOnly}
            variant={variant}
            focused={txtProps.focused}
          >
            <InputLabel> Unidad Fact: </InputLabel>
            <Select
              label="Facturacion En: "
              name="unidad_fact"
              value={props.dataCliente.unidad_fact}
              onChange={almacenar}
            >
              {unidadesFact
                ? unidadesFact.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento?.valor?.toUpperCase()}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid>

        {/* <Grid item xs={!props.edicion ? 4.5 : 6}> */}


        {/* <Grid item xs={5}>
          <FormControl
            focused={txtProps.focused}
            required
            style={style}
            variant={variant}
            size="small"
            disabled={readOnly}
          >
            <InputLabel>Segmento</InputLabel>
            <Select
              label="Segmento"
              name="id_segmento"
              value={props.dataCliente.id_segmento}
              onChange={(e) => {
                props.setDataCliente({
                  ...props.dataCliente,
                  id_segmento: e.target.value,
                  id_subsegmento: "",
                });
                getData(`/subsegmentos/seg/${e.target.value}`, setSubsegmentos);
              }}

            >
              {segmentos
                ? segmentos.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.segmento}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid> */}
        {/* <Grid item xs={5}>
          <FormControl
            focused={txtProps.focused}
            style={style}
            variant={variant}
            size="small"
            // disabled={readOnly}
            disabled

          >
            <InputLabel>Subsegmento</InputLabel>
            <Select
              label="Subsegmento"
              name="id_subsegmento"
              value={props.dataCliente.id_subsegmento}
              onChange={almacenar}
            >
              {subsegmentos
                ? subsegmentos.map((elemento) => (
                  <MenuItem key={elemento.id} value={elemento.id}>
                    {elemento.subsegmento} - {elemento.codigo_subsegmento}
                  </MenuItem>
                ))
                : null}
            </Select>
          </FormControl>
        </Grid> */}


        <Grid item xs={6}>
          <TextField
            focused={txtProps.focused}
            autoComplete="off"
            size="small"
            variant={variant}
            style={style}
            placeholder="Mails"
            name="mails"
            label="Mails"
            color="primary"
            value={props.dataCliente.mails}
            onChange={almacenar}
            required
            inputProps={{ maxLength: 500, readOnly: readOnly }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            focused={txtProps.focused}
            autoComplete="off"
            size="small"
            variant={variant}
            fullWidth
            type="text"
            color="primary"
            placeholder="Telefono 1"
            name="telefono1"
            label="Telefono 1"
            onChange={almacenar}
            value={props.dataCliente.telefono1}
            inputProps={{
              maxLength: 10,
              readOnly: readOnly,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{props.codArg}</InputAdornment>
              ),
            }}
            helperText="Código Área (sin 0) + número sin 15."
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            focused={txtProps.focused}
            autoComplete="off"
            size="small"
            variant={variant}
            fullWidth
            type="text"
            color="primary"
            placeholder="Telefono 2"
            name="telefono2"
            label="Telefono 2"
            onChange={almacenar}
            value={props.dataCliente.telefono2}
            inputProps={{
              maxLength: 10,
              readOnly: readOnly,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{props.codArg}</InputAdornment>
              ),
            }}
            helperText="Código Área (sin 0) + número sin 15."
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            onKeyDown={(e) => {
              if (e.key === "Tab") {
                props.setActiveTab("domicilio");
              }
            }}
            focused={txtProps.focused}
            autoComplete="off"
            size="small"
            variant={variant}
            fullWidth
            type="text"
            color="primary"
            placeholder="Telefono 3"
            name="telefono3"
            label="Telefono 3"
            onChange={almacenar}
            value={props.dataCliente.telefono3}
            inputProps={{
              maxLength: 10,
              readOnly: readOnly,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{props.codArg}</InputAdornment>
              ),
            }}
            helperText="Código Área (sin 0) + número sin 15."
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Grid>
      </Grid>
      {errorDialog && (
        <ErrorDialog
          open={errorDialog}
          setOpen={setErrorDialog}
          title={"CLIENTE EXISTENTE"}
          subtitle={
            "El CUIT/DNI que intenta ingresar YA FUE REGISTRADO bajo otra razón social. Revise el listado de clientes."
          }
        />
      )}
    </div>
  );
}

export default FormCliente;
